import { useMemo } from 'react';
import type { ReferencePrompt } from '@/app/types';
import { isAudioAndVoiceDisabled } from '@/app/utils';

export const useAudioLipSyncConstraint = (referencePrompts?: ReferencePrompt[]) => {
  const isSfxVoiceDisabled = useMemo(() => isAudioAndVoiceDisabled(referencePrompts), [referencePrompts]);

  return { isSfxVoiceDisabled };
};
